import Main from './Main.vue'
import Logs from './components/Logs'

export default [{
  path: 'logs',
  name: 'logs',
  component: Main,
  children: [
    {path: '/', component: Logs, name: 'logs'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/logs/routes.js